import Image from 'next/image';
import { memo } from 'react';

import { Modal, ModalCloseButton } from '@air/primitive-modal';

type NoPlanUpgradePermissionModalProps = object;

export const NoPlanUpgradePermissionModal = memo(({ onClose }: AirModalProps<NoPlanUpgradePermissionModalProps>) => {
  return (
    <Modal isOpen onDismiss={onClose}>
      <div className="flex flex-col items-center">
        <ModalCloseButton className="self-end" onClick={onClose} />
        <Image
          alt="Upgrade your plan"
          className="mb-4"
          height={170}
          src="/assets/illustrations/upgrade-to-pro.svg"
          width={170}
        />
        <p className="mb-2 font-semibold ads:text-accent text-24 text-blue-10">Upgrade your plan</p>
        <p className="text-center ads:text-secondary text-16 text-gray-11">
          Contact the admin of your workspace to upgrade your plan
        </p>
      </div>
    </Modal>
  );
});

NoPlanUpgradePermissionModal.displayName = 'NoPlanUpgradePermissionModal';
